import React from 'react';

import LoadingLinearProgress from 'components/LoadingLinearProgress';
import { useAppSelector } from 'hooks/redux';
import { getThemeMode } from 'themes/themesSelectors';

import RouterBackground from './RouterBackground';

const RouterLoadingProgress = () => {
  const themeMode = useAppSelector(getThemeMode);

  return (
    <RouterBackground>
      <LoadingLinearProgress />
      <img
        alt='loading...'
        src={themeMode === 'light' ? 'Quicken_Logo_animated.gif' : 'Quicken_Logo_animated_dark.gif'}
        height='100px'
        data-testid='loading-image'
      />
    </RouterBackground>
  );
};

export default RouterLoadingProgress;
